import { Link, useParams } from 'react-router-dom';
import { t } from '@/lib/i18n';
import { useMyGrants } from '../hooks';
import { ConnectorInvoker } from '../components/ConnectorInvoker';
import styles from './ConnectorDetailPage.module.css';

const STATUS_LABELS: Record<string, string> = {
  connected: 'Connected',
  not_connected: 'Not set up',
  error: 'Reconnect needed',
};

const STATUS_BADGE_CLASS: Record<string, string> = {
  connected: styles.statusConnected ?? '',
  not_connected: styles.statusNotConnected ?? '',
  error: styles.statusError ?? '',
};

export function ConnectorDetailPage() {
  const { connectorId } = useParams<{ connectorId: string }>();
  const { data } = useMyGrants();
  const connector = data?.connectors.find((c) => c.id === connectorId);

  return (
    <div className={styles.page}>
      <div className={styles.breadcrumb}>
        <Link to="/connectors" className={styles.breadcrumbLink}>
          {t('Connectors')}
        </Link>
        <span className={styles.breadcrumbSep}>›</span>
        <span className={styles.breadcrumbCurrent}>{connector?.name ?? connectorId}</span>
        {connector && (
          <span
            className={`${styles.statusBadge} ${STATUS_BADGE_CLASS[connector.connectorStatus] ?? ''}`}
          >
            {STATUS_LABELS[connector.connectorStatus]}
          </span>
        )}
      </div>
      <div className={styles.body}>
        {connectorId && <ConnectorInvoker connectorId={connectorId} />}
      </div>
    </div>
  );
}
